"use client"

import { CenterAligned, Modal, ModalBody, Spinner } from "@opensea/ui-kit"
import { useSnapshot } from "valtio"
import {
  MfaHandlerActions,
  MfaHandlerState,
} from "../../stores/mfaHandlerStore"
import { useOnMfaRequired } from "../useOnMfaRequired"
import { MfaChallenge } from "./MfaChallenge"
import { MfaEnrollment } from "./MfaEnrollment"

const MfaRequired = () => {
  const { needsEnrollment, needsAuthentication } = useSnapshot(MfaHandlerState)

  const renderContent = () => {
    if (needsEnrollment) {
      return <MfaEnrollment />
    }
    if (needsAuthentication) {
      return <MfaChallenge />
    }
    return (
      <CenterAligned className="h-[400px]">
        <Spinner />
      </CenterAligned>
    )
  }

  return <ModalBody className="text-center">{renderContent()}</ModalBody>
}

export const MfaHandler = () => {
  const { needsAuthentication, needsEnrollment } = useSnapshot(MfaHandlerState)

  useOnMfaRequired((mfaMethods, onComplete) => {
    MfaHandlerActions.startMfaChallenge(mfaMethods, onComplete)
  })

  return (
    <Modal
      className="md:rounded-xl"
      content={<MfaRequired />}
      onOpenChange={open => {
        if (!open) {
          MfaHandlerActions.cancelMfaChallenge()
        }
      }}
      open={needsAuthentication || needsEnrollment}
      size="sm"
    />
  )
}
